export default __webpack_public_path__ + "static/media/blog.6095b177.png";